import { Switch } from '@headlessui/react';
import { memo } from 'react';

interface SwitchToggleProps {
  onChange: (value: boolean) => void;
  switchedOn: boolean;
  disabled?: boolean;
  className?: string;
}

const SwitchToggle_: React.FC2<SwitchToggleProps> = ({ onChange, switchedOn, disabled = false, className }) => {
  return (
    <Switch
      checked={switchedOn}
      onChange={() => onChange(!switchedOn)}
      disabled={disabled}
      className={`${switchedOn ? (disabled ? 'bg-neon-green-700/50 dark:bg-neon-green-300/50' : 'bg-neon-green-700 dark:bg-neon-green-300') : disabled ? 'bg-gray-300/50 dark:bg-[#404040]/50' : 'bg-gray-300 dark:bg-[#404040]'} relative inline-flex h-6 w-11 items-center rounded-full ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className || ''}`}
    >
      <span className={`${switchedOn ? 'translate-x-6 dark:bg-ash-green-800' : 'translate-x-1 dark:bg-gray-400'} inline-block h-4 w-4 transform rounded-full bg-white transition ${disabled ? 'opacity-75' : ''}`} />
    </Switch>
  );
};

export const SwitchToggle = memo(SwitchToggle_);
